export enum EventName {
    GosSign = 'form_state_number',
    CarInfo = 'form_info_car',
    DateNewPolicy = 'form_date_new_policy',
    DriverInfo = 'form_info_driver',
    ApplyFastCalcIc = 'form_apply_fast_calc_ic',
    FullCalc = 'form_cost_calculation',
    ApplyFullCalcIc = 'form_apply_full_calc_ic',
    PayPolicy = 'form_switch_payment',
};

function selectedIcToEvent(icName?: string, isFull?: boolean) {
    let string = '';
    if (isFull)
        string = EventName.ApplyFullCalcIc;
    else
        string = EventName.ApplyFastCalcIc;

    if (!icName) {
        console.warn('ic name not found');
        return string;
    }

    return `${string}--${icName}`;
};

const eventsNeededIcName = [
    EventName.ApplyFastCalcIc,
    EventName.ApplyFullCalcIc
];

export function sendPostMessageEvent(event: EventName, icName?: string) {
    let eventString = `${event}`;
    if (eventsNeededIcName.includes(event)) {
        eventString = selectedIcToEvent(icName, event === EventName.ApplyFullCalcIc);
    }
    window.parent.postMessage(`ppd_analytic--${eventString}`, '*');
};
